/**
 * RustDesk — widget-first. Záložky a panely z module-ui-catalog.
 * ModulePage kreslí horní lištu; zámek rozvržení je na ModulePanel.
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('rustdesk');

export default function RustDesk() {
  return <ModuleWorkspace def={DEF} hideHeader defaultTab='stations' />;
}
